import React from "react";
import "./Techstacks.css";
import { FaReact, FaNodeJs, FaAws } from "react-icons/fa";
import {
  SiRedux,
  SiHtml5,
  SiExpress,
  SiRedis,
  SiTailwindcss,
  SiNetlify,
  SiPostman,
  SiPrisma,
  SiVercel,
  SiTypescript
} from "react-icons/si";
import { FaJava ,FaPython} from "react-icons/fa6";
import { FaGitAlt } from "react-icons/fa";
import { DiCss3, DiMongodb } from "react-icons/di";
import { SiJavascript} from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { BsBootstrap, BsWordpress } from "react-icons/bs";
import { BiLogoPostgresql } from "react-icons/bi";
import { RiNextjsFill } from "react-icons/ri";

export const Techstacks = () => {
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different" >Skills</h2>
        <div className="techsection">
        
          <div>
            <SiJavascript />
            <h5>Javascript</h5>
          </div>
          <div>
            <SiHtml5 />
            <h5>HTML</h5>
          </div>
          <div>
            <DiCss3 />
            <h5>CSS</h5>
          </div>
          <div>
            <SiTailwindcss />
            <h5>Tailwind CSS</h5>
          </div>
          <div>
            <FaReact />
            <h5>React</h5>
          </div>
          <div>
          <SiRedux />
            <h5>Redux Toolkit</h5>
          </div>
        
          <div>
            <FaNodeJs />
            <h5>Nodejs</h5>
          </div>
          <div>
            <DiMongodb />
            <h5>MongoDb</h5>
          </div>

          <div>
            <SiExpress />
            <h5>Express</h5>
          </div>          
          {/* <div>
            <BsBootstrap />
            <h5>Bootstrap</h5>
          </div> */}
          <div>
            <FaJava />
            <h5>Java</h5>
          </div>
          <div>
            <FaPython />
            <h5>Python</h5>
          </div>
          <div>
          <BiLogoPostgresql />
            <h5>Postgres SQL</h5>
          </div>
          <div>
          <SiPostman />
            <h5>Postman</h5>
          </div>
          <div>
          <FaGitAlt />
            <h5>Git</h5>
          </div>
          <div>
          <RiNextjsFill />
            <h5>NextJs</h5>
          </div>
          <div>
          <SiTypescript />
            <h5>Typescript</h5>
          </div>
          <div>
          <SiPrisma />
            <h5>Prisma</h5>
          </div>
          <div>
          <SiVercel />
            <h5>Vercel</h5>
          </div>
          

        </div>
      </div>
    </>
  );
};
